import Crud from '../views/RejectionType/Crud'
import Entity from '../views/RejectionType/Add'

let routes = {
    path: '/rejection_types',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/rejection_types/add',
            name: 'NewRejectionType',
            component: Entity,
            meta: {
                pageTitle: 'Tipo de Rejeição',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Adicionar Tipo de Rejeição',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/rejection_types/edit/:id?',
            name: 'EditRejectionType',
            component: Entity,
            meta: {
                pageTitle: 'Tipo de Rejeição',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Editar Tipo de Rejeição',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/rejection_types',
            name: 'list-rejection-types',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Tipos de Rejeições',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'Tipos de Rejeições',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
